const DEFAULT_VISIBLE_PRODUCT_LIMIT = 25

const normalizeText = (value) =>
  String(value || '')
    .trim()
    .toLowerCase()

const defaultGetOptionValue = (option) =>
  option?.value?.productCode || option?.productCode || option?.value || option

const defaultGetSearchText = (option) =>
  normalizeText(option?.searchText || option?.text)

const defaultGetSelectedValue = (selected) =>
  selected?.value?.productCode ||
  selected?.productCode ||
  selected?.value ||
  selected

const selectedProductOption = (selected) => {
  if (
    !selected?.productCode ||
    selected.supplierItemId == null ||
    !selected.tradeItemDescription
  ) {
    return undefined
  }

  return {
    text: `${selected.supplierItemId} / ${selected.tradeItemDescription}`,
    value: selected
  }
}

const dedupeOptions = (options, getOptionValue) => {
  const seen = new Set()

  return options.filter((option) => {
    const key = normalizeText(getOptionValue(option))

    if (seen.has(key)) {
      return false
    }

    seen.add(key)
    return true
  })
}

export const buildVisibleProductOptions = ({
  options = [],
  searchTerm = '',
  selectedValues = [],
  limit = DEFAULT_VISIBLE_PRODUCT_LIMIT,
  getOptionValue = defaultGetOptionValue,
  getSelectedValue = defaultGetSelectedValue,
  getSearchText = defaultGetSearchText
} = {}) => {
  const normalizedSearchTerm = normalizeText(searchTerm)
  const visibleOptions = normalizedSearchTerm
    ? options.filter((option) =>
        getSearchText(option).includes(normalizedSearchTerm)
      )
    : options.slice(0, limit)

  if (!selectedValues.length) {
    return visibleOptions
  }

  const selectedKeys = new Set(
    selectedValues
      .map((selected) => normalizeText(getSelectedValue(selected)))
      .filter(Boolean)
  )

  if (!selectedKeys.size) {
    return visibleOptions
  }

  const selectedOptions = options.filter((option) =>
    selectedKeys.has(normalizeText(getOptionValue(option)))
  )

  const missingSelectedOptions = selectedValues
    .filter(
      (selected) =>
        !selectedOptions.some(
          (option) =>
            normalizeText(getOptionValue(option)) ===
            normalizeText(getSelectedValue(selected))
        )
    )
    .map(selectedProductOption)
    .filter(Boolean)

  return dedupeOptions(
    visibleOptions.concat(selectedOptions, missingSelectedOptions),
    getOptionValue
  )
}

export { DEFAULT_VISIBLE_PRODUCT_LIMIT }
